import * as React from 'react';

import { BEAMER_ID } from 'env';

import { useConfigContext } from 'redesign/components/common/contexts/ConfigManager';

import { useAuthManager } from '../components/common/contexts/AuthManager';

interface BeamerProps {
    user_firstname?: string;
    user_lastname?: string;
    user_email?: string;
    user_id?: string;
    language?: string;
    filter?: string;
}

const BEAMER_URL = 'https://app.getbeamer.com/js/beamer-embed.js';

export const HAS_BEAMER = Boolean(typeof window !== 'undefined' && BEAMER_ID);

function beamerInitializer(config: BeamerProps = {}) {
    if (HAS_BEAMER) {
        window.beamer_config = {
            product_id: BEAMER_ID,
            button: false,
            ...config,
        };

        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.async = true;
        script.src = BEAMER_URL;
        head.appendChild(script);
    }
}

function useBeamer() {
    const { authData } = useAuthManager();
    const { config } = useConfigContext();
    React.useEffect(() => {
        if (authData?.user && config?.tenant_name) {
            const { id, language, roles } = authData.user;
            const userRolesFilter = roles.map(role => `user-role-${role}`).join(',');
            beamerInitializer({
                user_id: String(id),
                filter: `company-${config.company.toUpperCase()},tenant-${
                    config.tenant_name
                },${userRolesFilter}`.toLowerCase(),
                user_firstname: config.tenant_name,
                language,
            });
        }
    }, [authData?.user, config?.tenant_name, config?.company]);
}

export default useBeamer;
